// extracted by mini-css-extract-plugin
module.exports = {"text":"_2p_NbAl02tbdjsIkTj0v0s"};